/*
 * built-in-math-eval
 *
 * Copyright (c) 2015 Mauricio Poppe
 * Licensed under the MIT license.
 */

'use strict'

module.exports = require('./lib/eval')



//////////////////
// WEBPACK FOOTER
// ./node_modules/built-in-math-eval/index.js
// module id = voxF
// module chunks = 0